import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=2ac3e440&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=2ac3e440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3e440",
  null
  
)

export default component.exports